import React, { createContext, useContext, useState, ReactNode } from "react";

interface CheckoutContextType {
  groupedProducts: Record<string, any[]>;
  shippingCosts: Record<string, number>;
  setCheckoutData: (data: Partial<CheckoutContextType>) => void;
}

// Add children type to props
interface CheckoutProviderProps {
  children: ReactNode;
}

const CheckoutContext = createContext<CheckoutContextType | null>(null);

export const CheckoutProvider: React.FC<CheckoutProviderProps> = ({
  children,
}) => {
  const [checkoutData, setCheckoutData] = useState<CheckoutContextType>({
    groupedProducts: {},
    shippingCosts: {},
    setCheckoutData: () => {}, // Initialize setCheckoutData as a placeholder
  });

  const updateCheckoutData = (data: Partial<CheckoutContextType>) => {
    setCheckoutData((prev) => ({ ...prev, ...data }));
  };

  return (
    <CheckoutContext.Provider
      value={{ ...checkoutData, setCheckoutData: updateCheckoutData }}
    >
      {children}
    </CheckoutContext.Provider>
  );
};

export const useCheckoutContext = () => {
  const context = useContext(CheckoutContext);
  if (!context) {
    throw new Error("useCheckoutContext must be used within CheckoutProvider");
  }
  return context;
};
